export default "__VITE_ASSET__DbwOey4r__"